import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const NotFound = () => (
  <div data-testid="not-found-page">
    <section className="relative mx-auto flex min-h-[70vh] max-w-7xl flex-col items-start justify-center px-6 pt-28 pb-24 lg:px-10">
      <div aria-hidden="true" className="absolute -top-20 right-1/4 h-[24rem] w-[24rem] rounded-full bg-vortex-blue/15 blur-[130px]" />
      <p className="font-mono text-xs tracking-[0.25em] text-vortex-cyan uppercase">Error 404</p>
      <h1 className="mt-6 font-heading font-black tracking-tighter leading-[0.95] text-5xl sm:text-7xl">
        PAGE NOT <span className="text-vortex-cyan">FOUND.</span>
      </h1>
      <p className="mt-6 max-w-md text-base leading-relaxed text-slate-400">
        This page drifted out of the cooler. Head back home — everything else is
        stocked and where it should be.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="group mt-10 flex items-center gap-3 rounded-full bg-vortex-cyan px-8 py-4 font-mono text-xs tracking-[0.2em] uppercase text-vortex-ink transition-all duration-300 hover:shadow-[0_0_40px_rgba(92,179,226,0.5)]"
      >
        <ArrowLeft size={16} className="transition-transform duration-300 group-hover:-translate-x-1" />
        Back to home
      </Link>
    </section>
  </div>
);

export default NotFound;
